// Install-to-home-screen state. Separate from pwa.ts so screens and tests don't load the service worker module.

/** Chrome's install offer, kept so the help screen can show an "Install now" button. */
interface InstallPrompt extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}
let installPrompt: InstallPrompt | null = null;
const installListeners = new Set<() => void>();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault(); // we offer it on the help screen instead of a surprise banner
    installPrompt = e as InstallPrompt;
    installListeners.forEach((l) => l());
  });
  window.addEventListener("appinstalled", () => {
    installPrompt = null;
    installListeners.forEach((l) => l());
  });
}
export const canPromptInstall = () => installPrompt !== null;
export const onInstallChange = (fn: () => void) => {
  installListeners.add(fn);
  return () => void installListeners.delete(fn);
};
/** Opens Chrome's own install dialog. True when the user said yes. */
export async function promptInstall() {
  const p = installPrompt;
  if (!p) return false;
  installPrompt = null;
  await p.prompt();
  const { outcome } = await p.userChoice;
  installListeners.forEach((l) => l());
  return outcome === "accepted";
}
/** Already opened from the home screen icon. */
export const isInstalled = () =>
  (typeof window !== "undefined" && window.matchMedia?.("(display-mode: standalone)").matches) ||
  Boolean((navigator as Navigator & { standalone?: boolean }).standalone);
